module.exports = __webpack_public_path__ + "img/ball_7_green.59319a28.png";